import type { ReactElement } from 'react';
import React from 'react';
import { MfaQRCode } from '@hotjar/webapp/features/Mfa/components';
import { Button } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import { MfaEnforceEnableMfaPageStyles } from '../style';

const { Title, Description, ActionBar } = MfaEnforceEnableMfaPageStyles;

interface QrCodeStepProps {
  hasErrors: boolean;
  uri?: string;
  onBack: () => void;
  onNext: () => void;
}

export const QrCodeStep = ({ uri, hasErrors, onBack, onNext }: QrCodeStepProps): ReactElement => {
  const { t } = useTranslationWithPrefix('mfa:enforce-mfa.qr-code');

  return (
    <>
      <Title>{t('title')}</Title>

      <Description>
        {t('description-1')}
        <br />
        <br />
        {t('description-2')}
      </Description>

      {uri && <MfaQRCode uri={uri} hasErrors={hasErrors} isLoading={false} width="256px" />}

      <ActionBar marginTop="x4">
        <Button kind="secondary" onClick={onBack}>
          {t('back')}
        </Button>
        <Button kind="primary" onClick={onNext} type="submit">
          {t('action')}
        </Button>
      </ActionBar>
    </>
  );
};
